var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.819,
    height: 22.291,
    viewBox: "0 0 21.819 22.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3153",
    "data-name": "Rectangle 3153",
    width: 21.819,
    height: 22.291,
    fill: "#00b7cc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11095",
    "data-name": "Group 11095",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11094",
    "data-name": "Group 11094",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28992",
    "data-name": "Path 28992",
    d: "M18.555,7.454H13.362l1.146-3.816a2.826,2.826,0,0,0-5.13-2.267L6.16,6.733a1.483,1.483,0,0,1-1.273.721H1.6A1.6,1.6,0,0,0,0,9.057V20.688a1.6,1.6,0,0,0,1.6,1.6H16.287a3.262,3.262,0,0,0,3.149-2.406L21.7,11.576a3.264,3.264,0,0,0-3.148-4.122M1.781,9.235H4.154V20.51H1.781Zm18.2,1.876-2.267,8.308a1.48,1.48,0,0,1-1.43,1.092H5.934V9.055A3.249,3.249,0,0,0,7.685,7.65L10.9,2.289a1.046,1.046,0,0,1,1.9.839L11.587,7.172a1.6,1.6,0,0,0,1.534,2.062h5.434a1.486,1.486,0,0,1,1.43,1.876",
    transform: "translate(0 0)",
    fill: "#00b7cc",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon11);
export default __webpack_public_path__ + "static/media/icon11.1b5de8143f12700325eeca9d35fd8d4d.svg";
export { ForwardRef as ReactComponent };